/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1768
 */

"use strict"

var r = require(/* 257 */"../1754/257/index")
var /* [auto-meaningful-name] */require_950_$_950$left = require(/* 950 */"./950").left
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("reduce", function (e) {
  return require_950_$_950$left(r$aTypedArray(this), e, arguments.length, arguments.length > 1 ? arguments[1] : undefined)
})
